// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1ySBb","rootCenter":"LoadMoreObserver_rootCenter__3BKRb","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1o6ne"};